(function ($) {
	const faqItem = $('.faq-section');
	faqItem.on('click', function (event) {
		event.preventDefault();

		const answer = $(this).children('.faq-answer');
		answer.slideToggle('fast');
		answer.parent(faqItem).toggleClass('open');
	});
}(jQuery));